import React from 'react';

const Itemcard = () => {
    return(
        <>
        <div className="col-11 col-md-6 col-lg-3 mx-0 mb-4">
            <div class="card p-0 overflow-hidden h-100 shadow ">
               <img src='./images/img5.jpg' class="card-img-top img-fluid"/>
                    <div class="card-body">
                        <h5 class="card-title"> Marriages</h5>
                         <p class="card-text">Marriages are made in heaven</p>
                        <a href="Mar">Click to see more</a>
                    </div>
            </div>
        </div>
               <div className="col-11 col-md-6 col-lg-3 mx-0 mb-4">
                  <div class="card p-0 overflow-hidden h-100 shadow ">
                      <img src='./images/img7.jpg' class="card-img-top img-fluid"/>
                       <div class="card-body">
                         <h5 class="card-title">Haldi ceremony</h5>
                         <p class="card-text">make out the laughter</p>
                         <a href="">Click to see more</a>
                        </div>
                    </div>   

                </div>
                    <div className="col-11 col-md-6 col-lg-3 mx-0 mb-4">
                       <div class="card p-0 overflow-hidden h-100 shadow ">
                          <img src='./images/img3.jpg' class="card-img-top img-fluid"/>
                             <div class="card-body">
                                <h5 class="card-title">Cradle ceremony</h5>
                                <p class="card-text">Find out the name?</p>
                                <a href="">Click to see more</a>
                        </div>
                    </div>   

                </div>
                     <div className="col-11 col-md-6 col-lg-3 mx-0 mb-4">
                         <div class="card p-0 overflow-hidden h-100 shadow ">
                            <img src='./images/img8.jpg' class="card-img-top img-fluid"/>
                                <div class="card-body">
                                   <h5 class="card-title">DOTHI CEREMONY</h5>
                                   <p class="card-text">Never ending Happiness</p>
                                   <a href="">Click to see more</a>
                                 </div>
                         </div>   

                    </div>
                
                     <div className="col-11 col-md-6 col-lg-3 mx-0 mb-4">
                          <div class="card p-0 overflow-hidden h-100 shadow ">
                              <img src='./images/img9.jpg' class="card-img-top img-fluid"/>
                                   <div class="card-body">
                                      <h5 class="card-title">HALF SAREE CEREMONY</h5>
                                      <p class="card-text">cherish the Beauty</p>
                                      <a href="">Click to see more</a>
                                    </div>
                            </div>   

                        </div>            
                        <div className="col-11 col-md-6 col-lg-3 mx-0 mb-4">
                          <div class="card p-0 overflow-hidden h-100 shadow ">
                              <img src='./images/img12.jpg' class="card-img-top img-fluid"/>
                                   <div class="card-body">
                                      <h5 class="card-title">BRIDE TO BE</h5>
                                      <p class="card-text">Happy Bride!</p>
                                      <a href="">Click to see more</a>
                                    </div>
                            </div>   

                        </div>  
                        <div className="col-11 col-md-6 col-lg-3 mx-0 mb-4">
                          <div class="card p-0 overflow-hidden h-100 shadow ">
                              <img src='./images/img15.jpg' class="card-img-top img-fluid"/>
                                   <div class="card-body">
                                      <h5 class="card-title">DJ NIGHTS</h5>
                                      <p class="card-text">Dont Drunk and Drive!</p>
                                      <a href="">Click to see more</a>
                                    </div>
                            </div>   

                        </div> 
                        <div className="col-11 col-md-6 col-lg-3 mx-0 mb-4">
                          <div class="card p-0 overflow-hidden h-100 shadow ">
                              <img src='./images/img14.jpg' class="card-img-top img-fluid"/>
                                   <div class="card-body">
                                      <h5 class="card-title">CORPORATE EVENTS</h5>
                                      <p class="card-text">Have a Nice Day!</p>
                                      <a href="">Click to see more</a>
                                    </div>
                            </div>   

                        </div>  
                                            
            </>
            
        

    );
};
export default Itemcard;